import React, { useState } from 'react';
import * as Sentry from '@sentry/browser';
import { useTranslation } from 'react-i18next';
//icons

import arrowUpWhite from 'assets/icons/arrowUpWhite.svg';
//utils & constants
import { domain, loan_officer_app_client_id } from 'constants/constant';
//children components
import Consumer from './Consumer';
import LoanOfficer from './LoanOfficer';
import { formatPhoneNumber } from 'pages/profile/utils';
import fundmoreai from 'assets/fundmoreai2.png'

const PersonalInfoCard = () => {
  const { t } = useTranslation(['auth', 'common', 'validation', 'forms']);
  //form states
  const [consumerState, setConsumerState] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
  });
  const [loanOfficerState, setLoanOfficerState] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
  });

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const stateId = searchParams.get('state');
  const sessionToken = searchParams.get('session_token');
  const clientId = searchParams.get('clientId');
  const [role] = useState(
    clientId === loan_officer_app_client_id ? 'loanOfficer' : 'consumer'
  );
  const [onSubmit, setOnSubmit] = useState(false);

  const onSubmitButton = async () => {
    try {
      if (
        checkIfAnyError(
          role === 'consumer' ? consumerState : loanOfficerState,
          validationData
        )
      ) {
        setOnSubmit(true);
        setIsFormSubmitted(false);
        
        // Instead of making an API call, pass the data through the redirect URL
        const formData = role === 'consumer' ? consumerState : loanOfficerState;
        
        // Build the continue URL with all parameters
        const continueParams = new URLSearchParams({
          state: stateId,  // This is Auth0's state parameter - MUST be first
          session_token: sessionToken,
          firstName: formData.firstName || '',
          lastName: formData.lastName || '',
          phoneNumber: formData.phoneNumber || '',
          role: role === 'loanOfficer' ? 'loan_officer' : 'consumer',
          clientId: clientId  // Pass the clientId through as well
        });
        
        // Redirect back to Auth0's continue endpoint with the data
        window.location.href = `https://${domain}/continue?${continueParams.toString()}`;
      } else {
        setIsFormSubmitted(true);
      }
    } catch (error) {
      Sentry.captureException(error);
      setOnSubmit(false);
    }
  };
  const NanValidation = (data, property) => {
    if (isNaN(data[property]) || data[property].includes('-')) {
      return {
        isValid: false,
        hint: t('validation:numbersOnly'),
      };
    }
    return {
      isValid: true,
    };
  };
  const nullValidation = (data, property) => {
    if (data[property]) {
      return {
        isValid: true,
      };
    }
    return {
      isValid: false,
      hint: t('validation:fieldCannotBeEmpty'),
    };
  };
  const phoneValidation = (data, property) => {
    if (data[property].length === 10) {
      return {
        isValid: true,
      };
    }
    return {
      isValid: false,
      hint: t('validation:invalidPhone'),
    };
  };

  const checkIfAnyError = (data, validationData) => {
    for (const key in data) {
      if (key in validationData) {
        const validators = validationData[key];
        for (const validator of validators) {
          if (!validator(data, key)?.isValid) {
            return false;
          }
        }
      }
    }
    return true;
  };

  const validationData = {
    firstName: [nullValidation],
    lastName: [nullValidation],
    phoneNumber: [phoneValidation, NanValidation],
  };

  // format phone number
  const handleMobileNumberValue = (value) => {
    let formattedValue;
    const cleanedValue = ('' + value).replace(/\D/g, '');
    if (cleanedValue?.length === 10) {
      formattedValue = formatPhoneNumber(value, '(###) ###-####');
    } else {
      formattedValue = cleanedValue;
    }
    return formattedValue;
  };

  // disable buttons
  const onKeyPressPhoneNumber = (e) => {
    const regex = /[0-9]/;
    const key = String.fromCharCode(e.keyCode || e.which);

    if (!regex.test(key) && e.key !== 'Backspace') {
      e.preventDefault();
    }
  };

  return (
    <div
      className="bg-cover bg-center w-[100vw] h-screen flex flex-col justify-center items-center"
      style={{ backgroundImage: 'url("/mainbg.png")' }}
    >
      <div className="flex flex-col">
        <div className="w-[500px] h-[139px] bg-secondary100 flex flex-col justify-center items-center rounded-t-xl">
            <img
              src={fundmoreai}
              alt=""
              className="h-28"
              style={{width: '250px', height: '55px'}}
            />
          <h3 className="text-neutral900 h4-m mt-[-1rem]">
            {t('auth:onboarding.title')}
          </h3>
        </div>
        <div className="w-[500px] h-fit flex flex-col justify-center bg-white relative overflow-hidden rounded-b-xl">
          {role === 'consumer' ? (
            <Consumer
              setConsumerState={setConsumerState}
              consumerState={consumerState}
              validationData={validationData}
              isFormSubmitted={isFormSubmitted}
              handleMobileNumberValue={handleMobileNumberValue}
              onKeyPressPhoneNumber={onKeyPressPhoneNumber}
            />
          ) : (
            <LoanOfficer
              setLoanOfficerState={setLoanOfficerState}
              loanOfficerState={loanOfficerState}
              validationData={validationData}
              isFormSubmitted={isFormSubmitted}
              handleMobileNumberValue={handleMobileNumberValue}
              onKeyPressPhoneNumber={onKeyPressPhoneNumber}
            />
          )}
          <button
            className="btn-primary p-sm-bold h-[65px] text-tertiary w-[110%] flex flex-col justify-center self-center "
            onClick={onSubmitButton}
          >
            <div className="self-center flex flex-row gap-2">
              {onSubmit
                ? t('common:buttons.settingUpProfile')
                : t('common:buttons.completeSignUp')}
              {!onSubmit && (
                <img className="rotate-90" src={arrowUpWhite} alt="" />
              )}
            </div>
          </button>{' '}
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoCard;
